import React, { useContext } from 'react';
import { ResultsTable } from '../../../../DTOrderSearch.styles';
import { useSelector } from 'react-redux';
import { getOrdersSearchProperties, getOrderingSystem } from '../../../../../../../../selectors/tools';
import SearchHeader from '../../../SearchHeader/SearchHeader';
import { CustomHeaderContext } from '../../../SearchHeader/CustomHeaderContext';
import { ResultsHeaderColumn, ResultsHeaderRow, Results } from './SearchResultsLayout.styles';
import DTOrderSearchResultsList from '../DTOrderSearchResultsList/DTOrderSearchResultsList';
import { OnSelectOrderContextProvider } from './OnSelectOrderContext';
import { SearchResultsSettingsContext } from '../../SearchResultsSettingsContext';
import { splitAtUnderscoreCamelCaseOrDotAndUpperCase } from '../../../../../../../../util';
import { SHOPIFY } from '../../../../../../../../constants/orderingSystems';
export const SearchResultsLayout = (props) => {
  const { onSelectOrder } = props;
  const ordersSearch = useSelector(getOrdersSearchProperties);
  const headerComponent = useContext(CustomHeaderContext) || <SearchHeader />;
  const { useCustomLayout, settings } = useContext(SearchResultsSettingsContext);
  const orderingSystem = useSelector(getOrderingSystem);

  return (
    <Results key={'orderResults'}>
      {headerComponent}
      <ResultsTable>
        <ResultsHeaderRow>
          {useCustomLayout ? (
            Object.keys(settings).map((key) => (
              <ResultsHeaderColumn key={key}>{splitAtUnderscoreCamelCaseOrDotAndUpperCase(key)}</ResultsHeaderColumn>
            ))
          ) : (
            <>
              <ResultsHeaderColumn>ORDER NUMBER</ResultsHeaderColumn>
              <ResultsHeaderColumn>TOTAL</ResultsHeaderColumn>
              <ResultsHeaderColumn>BUYER</ResultsHeaderColumn>
              <ResultsHeaderColumn>DATE</ResultsHeaderColumn>
              {orderingSystem === SHOPIFY && <ResultsHeaderColumn>RISK</ResultsHeaderColumn>}
            </>
          )}
        </ResultsHeaderRow>
        <OnSelectOrderContextProvider value={onSelectOrder}>
          <DTOrderSearchResultsList orders={ordersSearch.orders} />
        </OnSelectOrderContextProvider>
      </ResultsTable>
    </Results>
  );
};
